import React, { Component } from 'react';

export class Dcl extends Component {
    static displayName = Dcl.name;

  constructor(props) {
    super(props);
      this.state = { currentCount: 0, targetDriverId : "" };
    this.incrementCounter = this.incrementCounter.bind(this);
  }

  incrementCounter() {
    this.setState({
      currentCount: this.state.currentCount + 1
    });
  }

    handleDriverInput = event => {
        this.setState({
            targetDriverId: event.target.value
        });
    };

  render() {
      return (
          <div class="container">
              <div class="row">
                  <div class="col-md-4 mb-3">
                      <h1 class="display-4">Driver Profile</h1>
                  </div>
                  <div class="col-md-8 mt-4">
                      <form>
                          <div class="form-row">
                              <div class="col-auto">
                                  <label class="sr-only" for="inlineFormInput">Name</label>
                                  <input type="text" class="form-control mb-2" id="inlineFormInput" placeholder="Search by Driver name"/>
			</div>

                                  <div class="col-auto">
                                      <button type="submit" class="btn btn-primary mb-2">Search</button>
                                  </div>
                              </div>
		</form>
		</div>
                  </div>
                  <div class="row">
                      <div class="card-group">
                          <div class="card" >
                              <img class="rounded-circle" src="N:\ETL\dev\MitelEasyPop\DriverPics\thojor.png" alt="Card image cap" />
                                  <div class="card-body">
                                      <h5 class="card-title">Bio</h5>
                                      <form class="needs-validation" novalidate>
                                          <div class="form-row">
                                              <div class="col-md-6 mb-3">
                                                  <label for="validationTooltip01">First name</label>
                                                  <input type="text" class="form-control" id="validationTooltip01" placeholder="First name" value="" required/>
                                                      <div class="valid-tooltip">
                                                          Looks good!
      </div>
    </div>
                                                  <div class="col-md-6 mb-3">
                                                      <label for="validationTooltip02">Last name</label>
                                                      <input type="text" class="form-control" id="validationTooltip02" placeholder="Last name" value="" required/>
                                                          <div class="valid-tooltip">
                                                              Looks good!
      </div>
    </div>
                                                  </div>
                                                  <div class="form-row">
                                                      <div class="col-md-6 mb-3">
                                                          <label for="validationTooltip01">DOB</label>
                                                          <input type="text" class="form-control" id="validationTooltip01" placeholder="DOB" value="" required/>
                                                              <div class="valid-tooltip">
                                                                  Looks good!
      </div>
    </div>
                                                          <div class="col-md-6 mb-3">
                                                              <label for="validationTooltip02">Phone</label>
                                                              <input type="text" class="form-control" id="validationTooltip02" placeholder="Phone" value="" required/>
                                                                  <div class="valid-tooltip">
                                                                      Looks good!
      </div>
    </div>
                                                          </div>

                                                          <div class="form-row">
                                                              <div class="col-md-6 mb-3">
                                                                  <label for="validationTooltip01">Tractor</label>
                                                                  <input type="text" class="form-control" id="validationTooltip01" placeholder="Tractor" value="" required/>
                                                                      <div class="valid-tooltip">
                                                                          Looks good!
      </div>
    </div>
                                                                  <div class="col-md-6 mb-3">
                                                                      <label for="validationTooltip02">Hire Date</label>
                                                                      <input type="text" class="form-control" id="validationTooltip02" placeholder="Hire Date" value="" required/>
                                                                          <div class="valid-tooltip">
                                                                              Looks good!
      </div>
    </div>
                                                                  </div>

                                                                  <button class="btn btn-primary" type="submit" disabled>Save</button>
</form>
                                                          </div>
                                                      </div>
                                                      <div class="card">
                                                          <div class="card-body">
                                                              <h5 class="card-title">Metrics</h5>
                                                              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
                                                          </div>
                                                      </div>
                                                      <div class="card">
                                                          <div class="card-body">
                                                              <h5 class="card-title">Call Log</h5>
                                                              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.</p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
    );
  }


    async populateDriverData() {
        let driverId = this.state.targetDriverId;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: driverId })
        };
        const response = await fetch('drivercalllog/driver', requestOptions);
        const data = await response.json();
        console.log(data);
    }

}
